import { Menu, Phone, Sun, X } from "lucide-react";
import { useEffect, useState } from "react";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navClass = scrolled ? "bg-white shadow-md" : "bg-transparent";

  return (
    <header className={`sticky top-0 z-50 transition ${navClass}`}>
      <div className="container-max flex items-center justify-between py-3 sm:py-4">
        <a href="#top" className="flex items-center gap-1.5 sm:gap-2 font-bold text-lg sm:text-xl md:text-2xl text-brand-blue">
          <span className="inline-flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full bg-[color:var(--brand-orange)] text-white flex-shrink-0">
            <Sun size={16} className="sm:size-18 md:size-20" />
          </span>
          <span className="truncate sm:whitespace-normal">PRUSHA TECHNOLOGY PVT LTD</span>
        </a>

        <nav className="hidden lg:flex items-center gap-6 text-sm">
          <a href="#plans" className="hover:text-[color:var(--brand-orange)] transition-colors">Plans</a>
          <a href="#features" className="hover:text-[color:var(--brand-orange)] transition-colors">Features</a>
          <a href="#coverage" className="hover:text-[color:var(--brand-orange)] transition-colors">Coverage</a>
          <a href="#contact" className="hover:text-[color:var(--brand-orange)] transition-colors">Contact</a>
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href="#contact" className="btn btn-primary text-sm">Get Connected</a>
          <a href="tel:+919712877584" className="btn btn-outline gap-2 text-sm whitespace-nowrap">
            <Phone size={16} /> +91 97128 77584
          </a>
        </div>

        <button
          className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu overlay */}
      {open && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setOpen(false)}
          />
          <div className="lg:hidden bg-white border-t shadow-lg">
            <div className="container-max py-4 flex flex-col gap-2">
              <a
                href="#plans"
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-lg hover:bg-gray-50 text-sm font-medium transition-colors"
              >
                Plans
              </a>
              <a
                href="#features"
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-lg hover:bg-gray-50 text-sm font-medium transition-colors"
              >
                Features
              </a>
              <a
                href="#coverage"
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-lg hover:bg-gray-50 text-sm font-medium transition-colors"
              >
                Coverage
              </a>
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-lg hover:bg-gray-50 text-sm font-medium transition-colors"
              >
                Contact
              </a>
              <div className="border-t pt-4 mt-4 space-y-3 px-4">
                <a href="#contact" className="btn btn-primary w-full" onClick={() => setOpen(false)}>
                  Get Connected
                </a>
                <a href="tel:+919712877584" className="btn btn-outline gap-2 w-full justify-center" onClick={() => setOpen(false)}>
                  <Phone size={16} /> +91 97128 77584
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </header>
  );
}

